module.exports = __webpack_public_path__ + "img/hr-burner-inserter-hand-closed.53f12091.png";